import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import "../../Style/Main.module.css";
import { useState } from "react";
import "../../Style/Data.module.css";
import { useStateValue } from "../../../../Hooks/stateProvider";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CustomNoRowsOverlay from "../../../../components/CustomNoRowsOverlay";
import ViewHistory from "../../../../components/ViewHistory";
import TakeActionDialogBox from "./TakeActionDialogBox";
import { encrypt } from "../../../../utils/cipher";
import Swal from "sweetalert2";
import { alert } from "../../../../utils/sweetAlert";
import axios from "axios";
import { ls } from "../../../../variables";
import Loader from "../../../../Loader/Loader";


export default function TrakerTable({ GTtype, tableData, trackerPageFetch, isInitialFetch, setIsInitialFetch, setBriefData,filters, submissionFlag}) {
  // const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [state, dispatch] = useStateValue();
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [alertIDs, setAlertIds] = useState([]);
  const annexureType = GTtype;

  const initialCtrColumns = [
    {
      field: "pmsName",
      headerName: "PMS  Name",
      minWidth: 110,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false
    },
    {
      field: "total_clauses",
      headerName: "Total Clauses",
      minWidth: 120,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "open_clauses",
      headerName: "Open Clauses",
      minWidth: 130,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "initial_response_received",
      headerName: "Initial Response Received",
      minWidth: 250,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false
    },
    {
      field: "clarification_sought",
      headerName: "Clarification Sought",
      minWidth: 170,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false
    },
    {
      field: "final_closure_pending",
      headerName: "Final Closure Pending",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    // {
    //   field: "submission_date",
    //   headerName: "Submission Date",
    //   minWidth: 150,
    //   flex: 0.5,
    //   align: "center",
    //   headerClassName: "header-blue",
    //   headerAlign: "center",
    //   sortable: false,
    // }
  ];

  const briefCtrColumns = [
    {
      field: "unreadAlert",
      headerName: "",
      minWidth: 30,
      maxWidth: 40,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.alert_status == "open (sebi)" && <PriorityHighIcon />}
          </div>
        );
      },
    },
    {
      field: "guidance_type",
      headerName: "Guidance Type",
      minWidth: 130,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
    },
    {
      field: "instance_count",
      headerName: "Instance Count",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "View",
      headerName: "Correspondance",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ paddingRight: "5px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  dispatch({
                    type: "SEBITrackerPageData",
                    SEBITrackerPageData: {
                      ticketID: params.row.ticket_id,
                      instanceID: params.row.case_id,
                      guidanceType: params.row.guidance_type,
                      viewStatus: params.row.alert_status,
                    },
                  });
                  setOpenHistoryModal(true);
                }}
              >
                View History
              </div>
            </div>
          </div>
        );
      },
    },
    // {
    //   field: "pmsComment",
    //   headerName: "PMS Comment",
    //   flex: 1,
    //   minWidth: 300,
    //   align: "center",
    //   headerClassName: "header-blue",
    //   headerAlign: "center",
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <div
    //         style={{
    //           minHeight: "2rem",
    //           maxHeight: "5rem",
    //           padding: "5px",
    //           whiteSpace: "pre-wrap",
    //           overflow: "auto",
    //         }}>{params.row.latest_comment}</div>
    //     );
    //   },
    // },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <button
            style={{
              color: "#ffffff",
              backgroundColor: params.row.alert_status == "open (sebi)" ? "#154063" : "#808080",
              border: params.row.alert_status == "open (sebi)" ? "0.125rem solid #154063" : "#808080",
              borderRadius: "0.125rem",
              width: "6.5rem",
              height: "1.875rem",
              cursor: params.row.alert_status == "open (sebi)" ? "pointer" : "initial"
            }}
            onClick={() => {
              dispatch({
                type: "SEBITrackerPageData",
                SEBITrackerPageData: {
                  ticketID: params.row.ticket_id,
                  instanceID: params.row.case_id,
                  guidanceType: params.row.guidance_type,
                  viewStatus: params.row.alert_status,
                  instanceCount: params.row.instance_count,
                  closedCount: params.row.closed_instance_count
                },
              });
              setOpenModal(true);
            }}
            disabled={params.row.alert_status == "open (sebi)" ? false : true}
          >Take Action</button>
        );
      },
    },
    {
      field: "reset",
      headerName: "Reset",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <button
            style={{
              color: "#ffffff",
              backgroundColor: params.row.alert_status == "closed" && !submissionFlag ? "#154063" : "#808080",
              border: params.row.alert_status == "closed" && !submissionFlag ? "0.125rem solid #154063" : "#808080",
              borderRadius: "0.125rem",
              width: "6.5rem",
              height: "1.875rem",
              cursor: params.row.alert_status == "closed" && !submissionFlag ? "pointer" : "initial"
            }}
            onClick={() => {
              handleReset(params.row.ticket_id, params.row.guidance_type)
            }}
            disabled={params.row.alert_status == "closed" && !submissionFlag ? false : true}
          >Reset</button>
        );
      },
    },
  ];

  let columns;
  console.log("rendertypesss",isInitialFetch)
  if (isInitialFetch === true) {
    columns = initialCtrColumns
  } else {
    columns = briefCtrColumns
  }


  let tempRows;
  if (annexureType != "") {
    tempRows = tableData?.filter((val) =>
      annexureType.includes(val.guidance_type)
    );
  } else {
    tempRows = tableData;
  }

  const handleReset = async (ticket_id, guidance_type) => {
    const encryptedPayload = await encrypt({
      "fy_year": filters.fy_year,
      "quarter": filters.quarter,
      "pmsName": filters.pmsName,
      "authToken": ls.get("authToken"),
      "refreshToken": ls.get("refreshToken"),
      "ticket_id": ticket_id,
      "guidance_type": guidance_type
    })
    Swal.fire({
      icon: "warning",
      title: "Are you sure about ticket reset?",
      text: "Responses once recorded, shall not be reverted later.",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (val.isConfirmed) {
        axios.post('/api/pms/resetTicket', { payload: encryptedPayload }, {
          withCredentials: true
        })
          .then((response) => {
            if (response?.data?.success) {
              alert("Ticket has been reset successfully!", "", "success")
              trackerPageFetch();
            }
            else {
              alert("Unable to reset!!", "", "error")
            }
          })
          .catch((err) => {
            alert("Unable to reset!!", "", "error")
          })
      }
    })
  }

  const rows = tempRows?.map((val, i) => ({ id: i + 1, ...val }));

  console.log("tempRows", rows)
  const handleRowClick = (params) => {
    if (params.row.pmsName && isInitialFetch ===true) {
      setIsInitialFetch(false);
      setBriefData(params.row);
    }
  }

  return (
    <div className="noTableOverflow" style={{ height: "100%", width: "100%", marginTop: "0%" }}>
      <Loader />
      <DataGrid
        getRowHeight={() => "auto"}
        rows={rows}
        columns={columns}
        rowSelectionModel={alertIDs}
        onRowSelectionModelChange={(selectedRowsID) => {
          const filteredSelection = selectedRowsID.filter((id) => {
            const selectedRow = rows.find((row) => row.id == id);
            return selectedRow.status === "open (sebi)" || "closed";
          });
          setAlertIds(filteredSelection);
          // console.log("ctrIds", ctrHytrIds);
        }}
        sx={{
          width: "fit-content",
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
          "& .MuiDataGrid-topContainer": { width: "fit-content" },
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
          "& .MuiDataGrid-overlayWrapper": {
            position: "static",
          },
        }}
        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        rowsPerPageOptions={[2, 5, 10]}
        AutoGenerateColumns={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        onRowClick={handleRowClick}
        disableColumnSelector
        scrollbarSize={0}
        autoPageSize
      />
      {openHistoryModal && (
        <ViewHistory
          openModal={openHistoryModal}
          setOpenModal={setOpenHistoryModal}
        />
      )}
      {openModal && (<TakeActionDialogBox openModal={openModal} setOpenModal={setOpenModal} trackerPageFetch={trackerPageFetch} />)}
    </div>
  );
}
